<template>
    <div class="order-details-box">
        <header class="lmy-header lmy-header-w" >
            <i class="iconfont icon-yuyin" onclick="window.history.go(-1)"></i>

	            会议详情
	    </header>
        <div class="infinite-loading-containers" style="margin-top:1.2rem" v-if="isLoading">
			<i class="loading-defaults"></i>
		</div>
        <div class="top" v-if="!isLoading">
            <div class="txt" v-if="!list.IsSucceed">
                <p class="order-type">等待顾问致电</p>
                <p>请保持手机畅通</p>
            </div>
            <div class="txt" v-else>
                <p class="order-type">订单已完成</p>
            </div>
            
        </div>
        <div class="middle" v-if="!isLoading">
            <div class="flow">
                <p class="title">订单服务流程</p>
                <i class="line"></i>
                <ul>
                    <li>
                        <div :class="list.Schedules>=0?'shape active':'shape'"></div>
                        <div :class="list.Schedules>=0?'':'txt'">提交需求</div>
                    </li>
                    <li>
                        <div :class="list.Schedules>=1?'shape active':'shape'"></div>
                        <div :class="list.Schedules>=1?'':'txt'">沟通需求</div>
                    </li>
                    <li>
                        <div :class="list.Schedules>=2?'shape active':'shape'"></div>
                        <div :class="list.Schedules>=2?'':'txt'">接收方案</div>
                    </li>
                    <li>
                        <div :class="list.Schedules>=3?'shape active':'shape'"></div>
                        <div :class="list.Schedules>=3?'':'txt'">预订场地</div>
                    </li>
                    <li>
                        <div :class="list.Schedules>=4?'shape active':'shape'"></div>
                        <div :class="list.Schedules>=4?'':'txt'">会议举办</div>
                    </li>
                </ul>
            </div>
        </div>
        <div class="bottom" v-if="!isLoading">
            <div class="details">
                <p class="title">我的需求详情</p>
                <ul>
                    <li>
                        <span class="lable">订单号：</span>
                        <span>{{list.CustomerNO}}</span>
                    </li>
                    <li>
                        <span class="lable">活动城市：</span>
                        <span>{{list.MettingVenue}}</span>
                    </li>
                    <li>
                        <span class="lable">活动类型：</span>
                        <span>{{list.MettingTypeDesc}}</span>
                    </li>
                    <li>
                        <span class="lable">活动需求：</span>
                        <span>{{list.ProjectServicesDesc}}</span>
                    </li>
                    <li>
                        <span class="lable">举办时间：</span>
                        <span>{{list.HoldingTime?list.HoldingTime.split('T')[0]:''}}</span>
                    </li>
                    <li>
                        <span class="lable">活动人数：</span>
                        <span>{{list.NumberOfPeopleDesc}}</span>
                    </li>
                    <li>
                        <span class="lable">活动预算：</span>
                        <span>{{list.BudgetDesc}}</span>
                    </li>
                    <li>
                        <span class="lable">联系电话：</span>
                        <span>{{list.PhoneNumber}}</span>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data(){
        return{
            list:{},
            isLoading:true
        }
    },
    methods:{
        query(){
            this.isLoading=true
            var params={
                id:this.$route.query.id
            }
            this.getRequest({
                url: this.Api.MeetingGet,
                params: params
            }).then(res => {
                    this.list = res
                    this.isLoading=false
            });
        }
    },
    created(){
        this.query()
    }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/usr/meeting/details.vue